import React from 'react'
import { Button, Group, Text } from '@mantine/core'
import { ThemeConfig } from '../../utils/themeConfig'

interface SubmitButtonProps {
  price?: Number
  loading: boolean
  themeConfig: ThemeConfig
}

export default function SubmitButton({ price, loading, themeConfig }: SubmitButtonProps) {
  return (
    <>
      <Group justify="space-between" mt="md">
        <Button
          loading={loading}
          type="submit"
          fullWidth
          radius="lg"
          size={'lg'}
          styles={{
            root: {
              background: themeConfig.primaryColor,
              height: '48px',
              fontSize: '16px',
              fontWeight: 600,
            },
          }}
        >
          <div className="flex flex-col items-center">
            <Text>{`¥${(price ?? 0).toFixed(2)} 立即查询`}</Text>
            <Text size="xs" opacity={0.9}>
              预计 15-60 秒生成
            </Text>
          </div>
        </Button>
      </Group>

      <div className="mt-4 flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 p-3">
        <span className="text-xs leading-relaxed text-amber-800">
          我司不提供央行征信和个人爬虫等隐私数据查询,也不提供贷款及信用修复等业务。所有要求你进行汇款、转账、非法刷单、买理财、承诺包下款的操作，都是诈骗！
        </span>
      </div>
    </>
  )
}
